import { render } from "./ImageEditorModal.vue?vue&type=template&id=74bafbb4&scoped=true"
import script from "./ImageEditorModal.vue?vue&type=script&lang=js"
export * from "./ImageEditorModal.vue?vue&type=script&lang=js"

import "./ImageEditorModal.vue?vue&type=style&index=0&id=74bafbb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bafbb4"]])

export default __exports__